<template>
  <v-app :class="loaded">
    <app-session-timeout-modal v-if="isTimedOut" />
    <app-header v-if="requiresAuth" />
    <router-view ref="view"></router-view>
    <app-footer v-if="requiresAuth" />
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FooterLoggedIn from '@/components/FooterLoggedIn'
import HeaderLoggedIn from '@/components/HeaderLoggedIn'
import SessionTimeoutModal from '@/components/SessionTimeoutModal'

export default {
  name: 'App',
  components: {
    'app-footer': FooterLoggedIn,
    'app-header': HeaderLoggedIn,
    'app-session-timeout-modal': SessionTimeoutModal
  },
  data: () => ({
    loaded: ''
  }),
  computed: {
    requiresAuth: function () {
      return this.$route.meta.requiresAuth
    },
    isTimedOut: function () {
      return this.$store.getters.sessionTimedOut
    }
  },
  created() {
    this.loadErrors()
  },
  mounted() {
    this.loaded = 'loaded'
  },
  methods: {
    ...mapActions(['loadErrors']),
    ...mapGetters(['sessionTimedout'])
  }
}
</script>
<style lang="scss">
// overlapped error-text fix
.v-input--checkbox {
  .v-label {
    height: auto;
  }
}
</style>
